import { Injectable } from '@angular/core';
import { ApiService } from '@app/services';
import { PearlsPlanningEventType, PearlsPlanningEvent, PearlsPlanningEventDto } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class PermanentPlaningEventService {

    constructor(
        private apiService: ApiService
    ) {}
    
    async loadEventsType(operationId: number): Promise<PearlsPlanningEventType[]>{
        let eventsTypes: Array<PearlsPlanningEventType> = [];
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.get('event/types', params);
        if(response?.data){
            eventsTypes = response.data;
        }
        return eventsTypes;
    }
    
    async loadEvent(operationId: number, eventId: number): Promise<PearlsPlanningEvent|null>{
        let event: PearlsPlanningEvent|null = null;
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.get('event/' + eventId + '/data', params);
        if(response?.data){
            event = PearlsPlanningEvent.FromJson(response.data);
        }
        return event;
    }
    
    async createEvent(operationId: number, event: PearlsPlanningEventDto): Promise<boolean>{
        let status = false;
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.post('event/create', event, params);
        if(response?.data){
            status = response.data;
        }
        return status;
    }
    
    async updateEvent(operationId: number, event: PearlsPlanningEventDto): Promise<boolean> {
        let status = false;
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.post('event/update', event, params);        
        if(response?.data){
            status = response.data;
        }
        return status;
    }
}
